import AddResult from './AddResult.vue';

export * from './types';
export default AddResult;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/forms/resultform/index.ts